{
	"title": "Материалы",
	"favorites": {
		"title": "Избранное",
		"subtitle": "{materials} · {sets}",
		"empty": {
			"title": "В избранном пока пусто",
			"description": "Добавляйте материалы или папки в избранное для быстрого доступа.",
			"cta": "К материалам"
		},
		"subtitleEmpty": "Пока пусто"
	},
	"subtitle": "{materials} · {sets}",
	"back": "Назад",
	"openInLibrary": "Открыть в моей библиотеке",
	"list": {
		"title": "Мои материалы",
		"empty": {
			"heading": "Тут будут все твои лекции, конспекты и PDF",
			"description": "Загрузи первый материал — StudyHub разберёт его на ключевые идеи, карточки и тест.",
			"cta": "Загрузить материал",
			"secondary": "Запись лекции"
		},
		"emptyFiltered": {
			"heading": "Ничего не найдено по фильтрам",
			"reset": "Сбросить фильтры"
		},
		"count": "{count, plural, =0 {Нет материалов} one {# материал} few {# материала} many {# материалов} other {# материала}}",
		"setsCount": "{count, plural, =0 {Нет папок} one {# папка} few {# папки} many {# папок} other {# папки}}",
		"searchPlaceholder": "Поиск по материалам",
		"view": {
			"grid": "Сеткой",
			"list": "Списком"
		},
		"sort": {
			"label": "Сортировка",
			"updatedAt": "По обновлению",
			"createdAt": "По дате создания",
			"title": "По названию"
		},
		"filters": {
			"type": "Тип",
			"set": "Папка",
			"status": "Статус",
			"tags": "Теги",
			"allTypes": "Все типы",
			"allSets": "Все папки",
			"allStatuses": "Все статусы",
			"reset": "Сбросить все",
			"recent": "Недавние",
			"favorite": "Избранное",
			"processing": "Обрабатываются",
			"ready": "Готовы",
			"sortLabel": "Сортировка"
		},
		"table": {
			"name": "Имя",
			"type": "Тип",
			"set": "Папка",
			"updated": "Обновлено",
			"status": "Статус",
			"actions": "Действия"
		},
		"loadMore": "Загрузить ещё",
		"showing": "Показано {shown} из {total}",
		"summary": "{total, plural, one {# материал} few {# материала} many {# материалов} other {# материала}} · {processing} в работе · {ready} готово",
		"row": {
			"noteReady": "Конспект готов",
			"noArtifacts": "Артефакты ещё не созданы",
			"actions": "Действия"
		},
		"errors": {
			"loadFailed": "Не удалось загрузить материалы",
			"retry": "Повторить"
		},
		"newSet": "Новая папка",
		"filtersButton": "Фильтры",
		"filtersSheet": {
			"title": "Фильтры и сортировка",
			"done": "Готово"
		},
		"swipe": {
			"delete": "В корзину",
			"favorite": "В избранное",
			"unfavorite": "Из избранного",
			"removeFromSet": "Убрать"
		}
	},
	"artifacts": {
		"note": "Конспект",
		"flashcards": "Карточки",
		"quiz": "Тест",
		"noteCount": "{count, plural, one {# конспект} few {# конспекта} many {# конспектов} other {# конспекта}}",
		"flashcardsCount": "{count, plural, one {# карточка} few {# карточки} many {# карточек} other {# карточки}}",
		"quizCount": "{count, plural, one {# тест} few {# теста} many {# тестов} other {# теста}}"
	},
	"card": {
		"openMenu": "Меню",
		"favorite": "В избранное",
		"unfavorite": "Убрать из избранного",
		"select": "Выбрать материал",
		"noSet": "Без папки",
		"processingProgress": "{percent}%"
	},
	"workspace": {
		"title": "Материал",
		"askAi": "Спросить о материале",
		"tabs": {
			"note": "Конспект",
			"flashcards": "Карточки",
			"quiz": "Тест",
			"glossary": "Глоссарий",
			"voice": "Голосовой репетитор",
			"recording": "Запись",
			"audio": "Аудио-резюме",
			"source": "Источник",
			"scrollLeft": "Прокрутить влево",
			"scrollRight": "Прокрутить вправо",
			"extracted": "Извлечённое"
		},
		"tabsLocked": {
			"audio": "Доступно на Plus"
		},
		"preview": {
			"page": "{current} / {total}",
			"noPreview": "Нет превью",
			"noPreviewDescription": "Этот формат пока не поддерживает встроенное превью",
			"openSource": "Открыть источник",
			"noText": "Текст ещё не извлечён из этого материала.",
			"processing": "Материал ещё обрабатывается…",
			"openDocument": "Открыть документ",
			"openDocumentHint": "Документ откроется в новой вкладке"
		},
		"panels": {
			"note": {
				"ready": "Конспект готов",
				"regenerate": "Регенерировать",
				"createNew": "Новый конспект",
				"levels": {
					"summarized": "Краткий",
					"in-depth": "Подробный",
					"comprehensive": "Полный"
				},
				"empty": "Конспект ещё не создан",
				"generate": "Создать конспект",
				"advanced": "Выбрать уровень детализации",
				"generating": "Генерируем конспект…",
				"generatingDescription": "Превращаем материал в структурированный конспект. Это займёт пару минут.",
				"listTitle": "Конспекты"
			},
			"flashcards": {
				"count": "{count, plural, one {# карточка} few {# карточки} many {# карточек} other {# карточки}}",
				"study": "Начать повторение",
				"empty": "Карточки ещё не созданы",
				"generate": "Создать карточки",
				"openSet": "Открыть набор",
				"generating": "Генерируем карточки…",
				"generatingDescription": "Создаём карточки для повторения. Это займёт пару минут.",
				"failed": "Не удалось сгенерировать карточки",
				"createNew": "Новый набор",
				"listTitle": "Наборы карточек"
			},
			"quiz": {
				"count": "{count, plural, one {# вопрос} few {# вопроса} many {# вопросов} other {# вопроса}}",
				"empty": "Тестов ещё нет",
				"generate": "Создать тест",
				"open": "Открыть тест",
				"generating": "Генерируем тест…",
				"generatingDescription": "Готовим вопросы по материалу. Это займёт пару минут.",
				"createNew": "Новый тест",
				"listTitle": "Тесты"
			},
			"recording": {
				"none": "Этот материал не из записи лекции",
				"open": "Открыть запись",
				"openList": "Открыть записи лекций"
			},
			"audio": {
				"empty": "Аудио-резюме не создавалось",
				"generate": "Создать аудио-резюме",
				"play": "Слушать",
				"generating": "Генерируем аудио-резюме…",
				"generatingDescription": "Генерируем аудио-резюме по материалу. Это займёт пару минут.",
				"createNew": "Новое аудио",
				"listTitle": "Аудио-резюме"
			},
			"voice": {
				"empty": "Голосовых сессий по материалу ещё не было",
				"start": "Начать голосовую сессию",
				"createNew": "Новая сессия",
				"open": "Открыть",
				"listTitle": "Голосовые сессии"
			}
		},
		"meta": {
			"pages": "{count, plural, one {# стр.} few {# стр.} many {# стр.} other {# стр.}}",
			"minutes": "{count, plural, one {# мин} few {# мин} many {# мин} other {# мин}}"
		},
		"artefacts": {
			"title": "Из этого материала",
			"flashcards": "{count, plural, one {# карточка} few {# карточки} many {# карточек} other {# карточки}}",
			"flashcardsSub": "Anki-формат, готовы к повторению",
			"quiz": "{count, plural, one {# вопрос теста} few {# вопроса теста} many {# вопросов теста} other {# вопроса теста}}",
			"quizSub": "Готов к прохождению",
			"audio": "{minutes} мин аудио",
			"audioSub": "Подкаст-диалог по материалу",
			"glossary": "{count, plural, one {# термин} few {# термина} many {# терминов} other {# термина}}",
			"glossarySub": "Авто-словарь по материалу",
			"voice": "{count, plural, one {# сессия} few {# сессии} many {# сессий} other {# сессии}}",
			"voiceSub": "Голосовой урок с AI-репетитором по материалу",
			"noteSub": "Структурированный AI-конспект материала",
			"noteReady": "{count, plural, one {# конспект готов} few {# конспекта готовы} many {# конспектов готовы} other {# конспекта готовы}}",
			"status": {
				"ready": "Готово",
				"missing": "Не создан",
				"generating": "Создаётся",
				"failed": "Ошибка"
			},
			"cta": {
				"generate": "Создать конспект",
				"create": "Создать",
				"retry": "Повторить",
				"openNote": "Открыть конспект",
				"openGlossary": "Открыть словарь",
				"startVoice": "Начать сессию"
			}
		},
		"ask": {
			"title": "Спроси по материалу",
			"placeholder": "Задай вопрос по материалу…",
			"samples": {
				"q1": "Объясни тему простыми словами",
				"q2": "Сделай краткое резюме материала",
				"q3": "Задай мне вопросы по теме",
				"q4": "Что здесь самое важное?"
			}
		},
		"favorite": "В избранное",
		"unfavorite": "Убрать из избранного",
		"share": "Поделиться",
		"regenerate": "Перегенерировать",
		"askTutor": "Начать чат",
		"voiceTutor": "Голосовой репетитор",
		"allMaterials": "Все материалы",
		"menu": "Меню",
		"actions": {
			"openNotes": "Все конспекты",
			"rename": "Переименовать",
			"delete": "Удалить материал"
		},
		"rename": {
			"title": "Переименовать материал",
			"label": "Название",
			"save": "Сохранить",
			"cancel": "Отмена"
		},
		"deleteConfirm": {
			"title": "Удалить материал?",
			"description": "Материал переместится в корзину на 30 дней, затем удалится навсегда.",
			"confirm": "Удалить",
			"cancel": "Отмена"
		},
		"toasts": {
			"genStarted": "Генерация запущена — это займёт пару минут",
			"genFailed": "Не удалось запустить генерацию",
			"genSlow": "Генерация идёт дольше обычного — результат появится здесь, как только будет готов",
			"shared": "Ссылка скопирована",
			"shareFailed": "Не удалось создать ссылку",
			"favorited": "Добавлено в избранное",
			"unfavorited": "Убрано из избранного",
			"regenerating": "Перегенерация запущена",
			"renamed": "Название обновлено",
			"deleted": "Материал удалён",
			"actionFailed": "Действие не выполнено",
			"offlineDeleteRequiresNetwork": "Удаление материала недоступно офлайн — подключитесь к сети"
		},
		"states": {
			"processing": "Обработка…",
			"processingDescription": "Обрабатываем материал — это займёт пару минут.",
			"materialProcessing": "Материал ещё обрабатывается",
			"materialProcessingDescription": "Дождись завершения обработки — затем можно сгенерировать карточки, тест и аудио.",
			"error": "Ошибка обработки",
			"errorDescription": "Что-то пошло не так. Попробуй повторить.",
			"retry": "Повторить обработку",
			"notFound": "Материал не найден",
			"notFoundDescription": "Материал удалён или у тебя нет к нему доступа.",
			"loadFailed": "Не удалось загрузить",
			"loadFailedDescription": "Проверь соединение и попробуй ещё раз.",
			"retryLoad": "Повторить",
			"syncPending": "Ожидаем синхронизацию",
			"syncPendingDescription": "Нет сети или данные ещё не синхронизировались. Попробуй позже.",
			"ready": "Готово",
			"queued": "В очереди",
			"generated": "Готово",
			"generatedDescription": "Материал создан — открываем.",
			"generatingShort": "Генерируется…"
		},
		"courses": {
			"title": "Используется в курсах",
			"empty": "Пока не входит ни в один курс.",
			"error": "Не удалось загрузить ссылки курса. Попробуйте позже.",
			"continueTopic": "Продолжить: {title}",
			"noProgram": "Программа ещё не сформирована",
			"add": "Добавить в курс",
			"addDescription": "Материал будет добавлен в источники курса и использован при формировании программы.",
			"addPlaceholder": "Выберите курс",
			"addEmpty": "Этот материал уже добавлен во все ваши курсы.",
			"addEmptyCta": "Перейти к курсам",
			"added": "Добавлено в курс",
			"addError": "Не удалось добавить в курс"
		},
		"video": {
			"transcript": "Транскрипт",
			"speed": "Скорость воспроизведения",
			"speedValue": "Скорость {rate}×",
			"rewind": "Назад на {seconds} с.",
			"forward": "Вперед на {seconds} с.",
			"captions": "Текущая строка транскрипта",
			"noTranscript": "У этого видео пока нет транскрипта.",
			"transcriptTruncated": "{count, plural, one {Не показан еще # фрагмент} few {Не показано еще # фрагмента} many {Не показано еще # фрагментов} other {Не показано еще # фрагмента}}"
		}
	},
	"upload": {
		"button": "Загрузить",
		"uploadMaterial": "Загрузить материал",
		"dialog": {
			"title": "Загрузить материал"
		},
		"tabs": {
			"file": "Файл",
			"link": "Ссылка",
			"text": "Текст"
		},
		"file": {
			"drop": "Перетащи файлы сюда или нажми, чтобы выбрать",
			"dropActive": "Отпусти файлы",
			"formats": "PDF · Word · Excel · PowerPoint · Text · Markdown · фото · аудио · видео",
			"unsupported": "Этот формат не поддерживается.",
			"tooMany": "Можно загрузить до {max} файлов одновременно.",
			"maxFiles": "До {max} файлов за раз",
			"phaseHashing": "Подготовка файлов…",
			"phaseUploading": "Загрузка: {percent}%",
			"phaseUploadingBatch": "Загрузка {current}/{total}: {percent}%",
			"phaseFinalizing": "Обработка…",
			"phasePacking": "Начало упаковки папки…",
			"processingHint": "Не закрывай окно, пока файлы загружаются.",
			"choose": "Выбрать файлы",
			"chooseHint": "Или перетащи файлы сюда",
			"addMore": "Добавить еще файлы",
			"readyHint": "Файлы готовы — выберите курс или папку, затем нажмите «Готово»."
		},
		"link": {
			"placeholder": "Вставь ссылку на YouTube или веб-страницу",
			"hint": "YouTube или любая веб-страница — распознаем автоматически",
			"detectedYoutube": "Распознано: YouTube",
			"detectedWebpage": "Распознано: веб-страница",
			"submit": "Добавить"
		},
		"text": {
			"titlePlaceholder": "Название (необязательно)",
			"contentPlaceholder": "Вставь или напиши текст…",
			"untitled": "Без названия",
			"submit": "Сохранить"
		},
		"cancel": "Отмена",
		"done": "Готово",
		"duplicate": "Этот материал уже загружен",
		"destination": "Куда добавить",
		"course": {
			"label": "Курс",
			"placeholder": "Выбери курс",
			"search": "Поиск курса",
			"newCourse": "＋ Новый курс",
			"newCoursePlaceholder": "Название курса",
			"libraryOnly": "Только в библиотеку",
			"empty": "Курсов пока нет",
			"current": "В курс: {course}",
			"change": "изменить"
		},
		"folder": {
			"label": "Папка",
			"placeholder": "Без папки",
			"search": "Поиск папки",
			"newFolder": "＋ Новая папка",
			"newFolderPlaceholder": "Название папки",
			"empty": "Папок пока нет"
		},
		"hint": "Построим программу по этим материалам",
		"hintLibraryOnly": "Материалы останутся в библиотеке — программу не строим",
		"bridge": {
			"title": "{count, plural, one {Обработан # материал} few {Обработано # материала} many {Обработано # материалов} other {Обработано # материалов}}",
			"description": "Программа курса «{course}» готова к продолжению.",
			"action": "Перейти к обучению",
			"dismiss": "Позже"
		},
		"types": {
			"pdf": "PDF",
			"doc": "Документ",
			"spreadsheet": "Таблица",
			"presentation": "Презентация",
			"image": "Изображение",
			"audio": "Аудио",
			"video": "Видео",
			"youtube": "YouTube",
			"webpage": "Веб-страница",
			"text": "Текст",
			"note": "Заметка"
		},
		"kindBadge": {
			"pdf": "PDF",
			"doc": "DOC",
			"text": "TEXT",
			"image": "IMAGE",
			"audio": "AUDIO",
			"video": "VIDEO",
			"youtube": "YT",
			"web": "WEB"
		},
		"progress": "Загрузка: {percent}%",
		"success": "Материал загружен",
		"successToCollection": "Материал добавлен в папку",
		"successToNewCollection": "Файлы загружены — папка создана",
		"errors": {
			"tooLarge": "Файл слишком большой (максимум {maxMb} МБ)",
			"tooLargeTier": "Файл превышает лимит твоего тарифа",
			"unsupportedType": "Этот формат не поддерживается",
			"quotaExceeded": "Достигнут лимит тарифа на материалы",
			"invalidUrl": "Проверь ссылку — кажется, она некорректна",
			"network": "Не удалось загрузить. Проверь соединение и попробуй снова",
			"generic": "Что-то пошло не так. Попробуй ещё раз",
			"tooLargeLimit": "Файл слишком большой для загрузки",
			"quotaReachedLimit": "Достигнут лимит материалов"
		}
	},
	"status": {
		"queued": "В очереди",
		"processing": "Обработка",
		"ready": "Готово",
		"partial": "Частично готов",
		"failed": "Ошибка обработки",
		"retry": "Повторить обработку"
	},
	"sets": {
		"title": "Папки",
		"createButton": "Создать папку",
		"empty": "Нет папок",
		"namePlaceholder": "Название папки",
		"counters": {
			"empty": "Пусто",
			"materials": "{count, plural, =0 {В этой папке нет материалов} one {# материал в этой папке} few {# материала в этой папке} many {# материалов в этой папке} other {# материала в этой папке}}",
			"flashcards": "{count, plural, =0 {Карточки еще не созданы} one {# карточка создана из этой папки} few {# карточки созданы из этой папки} many {# карточек создано из этой папки} other {# карточки созданы из этой папки}}",
			"tests": "{count, plural, =0 {Тесты еще не созданы} one {# тест создан из этой папки} few {# теста создано из этой папки} many {# тестов создано из этой папки} other {# теста создано из этой папки}}"
		},
		"list": {
			"title": "Папки",
			"subtitle": "{count, plural, =0 {Нет папок} one {# папка} few {# папки} many {# папок} other {# папки}} · {materialsCount, plural, =0 {нет материалов} one {# материал} few {# материала} many {# материалов} other {# материала}}",
			"search": "Поиск по названию",
			"empty": {
				"title": "Папок пока нет",
				"subtitle": "Группируй материалы по предмету или курсу",
				"cta": "Создать первую папку"
			},
			"emptyFiltered": {
				"heading": "Ничего не найдено",
				"hint": "Измени запрос или сбрось фильтры"
			},
			"card": {
				"materials": "{count, plural, =0 {Нет материалов} one {# материал} few {# материала} many {# материалов} other {# материала}}",
				"flashcards": "{count, plural, =0 {0 карточек} one {# карточка} few {# карточки} many {# карточек} other {# карточки}}",
				"tests": "{count, plural, =0 {0 тестов} one {# тест} few {# теста} many {# тестов} other {# теста}}"
			},
			"view": {
				"label": "Вид",
				"grid": "Сетка",
				"table": "Список"
			},
			"sort": {
				"label": "Сортировка",
				"placeholder": "По изменению",
				"updatedAt": "По изменению",
				"createdAt": "По созданию",
				"name": "По названию",
				"materialsCount": "По числу материалов"
			},
			"table": {
				"name": "Название",
				"description": "Описание",
				"materials": "Материалы",
				"flashcards": "Карточки",
				"tests": "Тесты",
				"updated": "Изменена",
				"created": "Создана",
				"actions": ""
			},
			"reorder": {
				"toastSuccess": "Порядок папок сохранен",
				"toastError": "Не удалось сохранить порядок",
				"dragHandle": "Перетащить",
				"moveUp": "Поднять выше",
				"moveDown": "Опустить ниже"
			}
		},
		"detail": {
			"stats": "{materials} материалов · {flashcards} карточек · {quizzes} тестов",
			"share": "Поделиться",
			"shareCopied": "Ссылка скопирована",
			"shareRevoke": "Отозвать",
			"addMaterials": "Добавить материалы",
			"reorder": "Изменить порядок",
			"searchInSet": "Поиск в папке",
			"empty": "Эта папка пока пуста",
			"emptyAdd": "Добавить материалы",
			"removeFromSet": "Удалить из папки",
			"removedFromSet": "Материал удален из папки"
		},
		"menu": {
			"aria": "Действия с папкой",
			"open": "Открыть",
			"rename": "Изменить",
			"color": "Сменить цвет",
			"share": "Поделиться",
			"shareCopied": "Ссылка скопирована",
			"revokeShare": "Закрыть доступ",
			"shareRevoked": "Доступ закрыт",
			"duplicate": "Дублировать",
			"duplicateStarted": "Дублирование папки — материалы появятся через несколько секунд",
			"duplicateReady": "Копия папки готова",
			"duplicateError": "Не удалось дублировать папку",
			"export": "Экспортировать",
			"exportStarted": "Готовим архив — пришлём ссылку",
			"exportReady": "Архив папки готов — начнется загрузка",
			"exportError": "Не удалось экспортировать папку",
			"delete": "Удалить",
			"moveUp": "Переместить вверх",
			"moveDown": "Переместить вниз",
			"movedUp": "Папка перемещена вверх",
			"movedDown": "Папка перемещена вниз"
		},
		"delete": {
			"title": "Удалить эту папку?",
			"body": "Материалы внутри папки НЕ будут удалены. Папка и ее общие артефакты переместятся в корзину на 30 дней.",
			"cta": "Удалить папку",
			"success": "Папка удалена",
			"error": "Не удалось удалить папку",
			"removedFromAnotherDevice": "Папка удалена с другого устройства"
		},
		"edit": {
			"title": "Редактировать папку",
			"subtitle": "Название, описание и цвет.",
			"nameLabel": "Название",
			"descriptionLabel": "Описание",
			"colorLabel": "Цвет",
			"cta": "Сохранить",
			"cancel": "Отмена",
			"success": "Изменения сохранены",
			"error": "Не удалось сохранить"
		},
		"addMaterialsDialog": {
			"title": "Добавить материалы в папку",
			"subtitle": "Выберите материалы из библиотеки, которых еще нет в этой папке.",
			"success": "Материалы добавлены в папку",
			"error": "Не удалось добавить материалы",
			"cancel": "Отмена",
			"cta": "{count, plural, =0 {Добавить} one {Добавить # материал} few {Добавить # материала} many {Добавить # материалов} other {Добавить # материалов}}"
		}
	},
	"trash": {
		"title": "Корзина",
		"subtitle": "{count, plural, =0 {Корзина пуста} one {# материал} few {# материала} many {# материалов} other {# материала}} · хранятся 30 дней",
		"banner": "Материалы хранятся 30 дней, после чего удаляются без возможности восстановления. При восстановлении папки ссылки на материалы сохраняются.",
		"restore": "Восстановить",
		"delete": "Удалить безвозвратно",
		"emptyTrash": "Очистить корзину",
		"emptyTrashConfirm": "Очистить корзину?",
		"emptyTrashConfirmDescription": "Все материалы будут удалены без возможности восстановления. Введи «УДАЛИТЬ» для подтверждения.",
		"deleteWord": "УДАЛИТЬ",
		"deletesIn": "Удалится через {days}д {hours}ч",
		"deletedAt": "Удалено {time}",
		"empty": {
			"heading": "Корзина пуста",
			"description": "Удалённые материалы попадают сюда и хранятся 30 дней."
		},
		"table": {
			"name": "Имя",
			"type": "Тип",
			"size": "Размер",
			"deleted": "Удалено",
			"expiresIn": "Удалится через"
		},
		"selected": "Выбрано: {count}",
		"restored": "Материал восстановлен",
		"emptied": "Корзина очищена"
	},
	"share": {
		"title": "Поделиться материалом",
		"copyLink": "Скопировать ссылку",
		"linkCopied": "Ссылка скопирована",
		"expiresIn": "Срок действия: {days} дней",
		"publicHeading": "Публичный материал",
		"publicSubheading": "Чтобы открыть тест, чат с AI или повторение карточек — войди в StudyHub.",
		"signupCta": "Создать аккаунт",
		"watermark": "Опубликовано в StudyHub",
		"viewBy": "Открыл: {name}",
		"notFoundTitle": "Ссылка недоступна",
		"notFoundDescription": "Эта ссылка недействительна, истекла или была отозвана владельцем.",
		"contentEmpty": "У этого материала нет текстового содержимого для предпросмотра.",
		"setHeading": "Общая папка",
		"setMaterialsCount": "{count, plural, one {# материал} few {# материала} other {# материалов}}",
		"openInApp": "Открыть в StudyHub"
	},
	"actions": {
		"open": "Открыть",
		"rename": "Переименовать",
		"moveToSet": "Переместить в папку",
		"share": "Поделиться",
		"download": "Скачать",
		"duplicate": "Дублировать",
		"delete": "Удалить материал",
		"deleteConfirm": "Удалить материал и все связанные конспекты, карточки и тесты?"
	},
	"processing": {
		"status": {
			"queued": "В очереди",
			"uploading": "Загрузка",
			"parsing": "Чтение содержимого",
			"ocr": "Распознавание текста",
			"chunking": "Разбивка на фрагменты",
			"embedding": "Построение индекса",
			"ready": "Готово",
			"failed": "Ошибка обработки",
			"partial": "Частично готово",
			"cancelled": "Отменено",
			"unknown": "Обработка"
		},
		"actions": {
			"retry": "Повторить"
		},
		"errorCode": {
			"no-text-extractable": "Не удалось извлечь текст из файла",
			"no-speech-detected": "В аудио не обнаружена речь",
			"ai-timeout": "AI слишком долго не отвечает",
			"safety-filter": "Контент заблокирован фильтром безопасности",
			"file-too-large": "Файл слишком большой",
			"unsupported-format": "Неподдерживаемый формат файла",
			"unsupported-type": "Неподдерживаемый тип материала",
			"pdf-encrypted": "PDF защищён паролем",
			"pdf-too-many-pages-for-ocr": "Слишком много страниц для распознавания текста",
			"youtube-private": "Видео приватное",
			"youtube-not-found": "Видео не найдено",
			"youtube-invalid-url": "Некорректная ссылка на видео",
			"youtube-live-stream": "Прямые трансляции не поддерживаются",
			"youtube-too-long": "Видео слишком длинное",
			"webpage-paywall": "Страница за платным доступом",
			"webpage-no-content": "Не удалось найти контент на странице",
			"webpage-blocked": "Доступ к странице заблокирован",
			"audio-too-long": "Аудио слишком длинное",
			"pptx-too-many-slides-for-ocr": "Слишком много слайдов для распознавания текста",
			"rate-limit": "Достигнут лимит запросов, попробуй позже",
			"quota-exceeded": "Превышена квота на обработку",
			"material-not-found": "Материал не найден",
			"type-mismatch": "Тип файла не совпадает с материалом",
			"invalid-source": "Источник материала повреждён или не сохранён",
			"user-cancelled": "Обработка отменена",
			"provider-unavailable": "AI-сервис временно недоступен",
			"mime-mismatch": "Формат файла не соответствует расширению",
			"upload-incomplete": "Загрузка не завершилась",
			"internal-error": "Внутренняя ошибка",
			"claim-idempotency": "Обработка уже выполняется",
			"validate": "Не пройдена проверка файла",
			"thin": "На странице слишком мало читаемого текста — возможно, это скрипт или контент заблокирован. Вставьте текст вручную или попробуйте другой источник"
		},
		"stages": {
			"text": "Извлечение текста",
			"index": "Индексация",
			"assets": "Таблицы и изображения",
			"assetsBackground": "— в фоне"
		}
	},
	"extracted": {
		"sourceChipWithPage": "{name} · стр. {page}",
		"lightboxAria": "Просмотр изображения",
		"close": "Закрыть",
		"loadFailed": "Не удалось загрузить извлеченный контент",
		"retry": "Повторить",
		"page": "стр. {page}",
		"openFigure": "Открыть рисунок: {name}",
		"hide": "Скрыть из предложений ИИ",
		"unhide": "Вернуться к подсказкам ИИ",
		"hiddenLabel": "{name} — скрыто",
		"kind": {
			"figure": "Диаграмма",
			"photo": "Фото",
			"formula": "Формула",
			"chart": "График",
			"screenshot": "Скриншот",
			"table-image": "Изображение таблицы",
			"page-render": "Страница"
		},
		"summary": {
			"pages": "{count, plural, one {# страница} few {# страницы} many {# страниц} other {# страницы}}",
			"tables": "{count, plural, one {# таблица} few {# таблицы} many {# таблиц} other {# таблицы}}",
			"figures": "{count, plural, one {# иллюстрация} few {# иллюстрации} many {# иллюстраций} other {# иллюстраций}}"
		},
		"figures": {
			"title": "Иллюстрации",
			"empty": "Иллюстраций не найдено",
			"pending": "Идёт извлечение иллюстраций"
		},
		"tables": {
			"title": "Таблицы",
			"empty": "Таблиц не найдено",
			"untitled": "Таблица без названия",
			"size": "{rows}×{cols}",
			"irregular": "упрощенный вид",
			"expand": "Развернуть",
			"collapse": "Свернуть",
			"noProjection": "Разметка таблицы недоступна",
			"pending": "Идёт извлечение таблиц"
		}
	}
}
